import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { TranslationService } from 'src/app/i18n/translation.service';
import { SharedService } from 'src/app/services/shared.service';

@Component({
  selector: 'app-btn-one',
  templateUrl: './btn-one.component.html',
  styleUrls: ['./btn-one.component.scss'],
  encapsulation:ViewEncapsulation.None
})
export class BtnOneComponent implements OnInit {
  @Input() queryParams: any = {};
  @Input() link: string = "";
  @Input() text: string = "";
  @Input() textClass: string = " text-base";
  @Input() seoDesc: string = "";
  @Input() svg: string = "";
  @Input() svgClass: string = "";
  @Input() isDisabled: boolean = false;
  @Input() styleColor: string = "green-blue";//red-purple
  @Output() onClick: EventEmitter<boolean> = new EventEmitter();

  private routerSubscription: Subscription = new Subscription();

  lang: string = 'en';
  constructor(
    private sharedService: SharedService,
    private TranslationService: TranslationService,
    private router: Router,    
  ) {
    this.lang = this.TranslationService.getSelectedLanguage();
    this.routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.lang = this.TranslationService.getSelectedLanguage();        
      }
    });
  }

  ngOnDestroy(): void {
    // Clean up router subscription when the component is destroyed
    this.routerSubscription.unsubscribe();
  }  

  ngOnInit(): void { }

  onClickFire() {
    if (!this.isDisabled) this.onClick.emit();
  }

  isExternalMethod(link: string) {
    return this.sharedService.isExternalMethod(link);
  }

}
